import { useContext } from 'react'
import { ActiveWorkoutContext } from 'context/ActiveWorkoutContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'
import OutlineButton from 'components/Buttons/OutlineButton'

export default function ResumeActiveWorkoutCard({ activeWorkout }) {

    // console.log(activeWorkout)

    const { DiscardActiveWorkoutWarningModal, EndActiveWorkoutWarningModal, ResumeActiveWorkout } = useContext(ActiveWorkoutContext)

    return (
        <div className="flex items-center p-4 gap-x-2 bg-white rounded-xl border border-gray-400 shadow-lg">
            <p className='text-lg truncate'>
                {activeWorkout.profileType === 'group' && activeWorkout.groupName}
                {activeWorkout.profileType === 'individual' && activeWorkout.athleteName}
                {' '}
                -
                {' '}
                {activeWorkout.workoutTemplate.name}
            </p>

            <div className='flex-1' />

            <div className='w-24'>
                <BrandColorButton
                    size="small"
                    text="Resume"
                    action={() => ResumeActiveWorkout(activeWorkout.profileType, activeWorkout.groupId, activeWorkout.athleteId)}
                />
            </div>

            <div className='w-24'>
                <OutlineButton
                    size="small"
                    text="Discard"
                    action={() => DiscardActiveWorkoutWarningModal(activeWorkout.id, activeWorkout.profileType, activeWorkout.groupId, activeWorkout.athleteId)}
                />
            </div>

            <div className='w-24'>
                <OutlineButton
                    size="small"
                    text="End"
                    action={() => EndActiveWorkoutWarningModal(activeWorkout, '/home')}
                />
            </div>
        </div>
    )
}